/*
* @Author: abhishek714
* @Date:   2025-03-10 12:25:59
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-03-19 16:10:03
*/
import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { urlPath, SITE_URL } from '../../constants.js';
import adminUserIcon from '../../images/admin-user-img.png';
import associateUserIcon from '../../images/associate-img.png';
import barIcon from '../../images/bar-icon.png';

class SideBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			userData:{}
		}
	}

	componentDidMount() {
        this.setState({
            userData: {
                user_id: localStorage.getItem("techtop_user_id") || '',
                user_role: localStorage.getItem("techtop_user_user_role"),
                is_show_net_pricing: localStorage.getItem("techtop_user_is_show_net_pricing") === "true",
                is_show_open_order: localStorage.getItem("techtop_user_is_show_open_order") === "true",
                is_show_order_history: localStorage.getItem("techtop_user_is_show_order_history") === "true",
                is_subscribe_newsletter: localStorage.getItem("techtop_user_is_subscribe_newsletter") === "true"
            }
        });
    }

	render() {
		const { page } = this.props;
        const { userData } = this.state;
        const isAssociate = userData.user_role === 'associate';
		return(
			<React.Fragment>
				<div className="admin-user-sidebar">
					<div className="d-block d-md-none">
						<a className="sidebar-bar-icon" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
							<img src={barIcon} alt="bar-icon" />
						</a>
						<div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
							<div className="offcanvas-header">
								<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
							</div>
							<div className="offcanvas-body">
								<div className="techtop-adminBox">
									<img src={isAssociate ? associateUserIcon : adminUserIcon} alt="User Role" />
                                    <strong>{isAssociate ? 'Associate' : 'Admin'} User</strong>
								</div>
								<div className="techtop-adminlist">
									<ul>
										<li><a href="/user/my-account" className={(page === 'my-account') && "active"}>My Account</a></li>
										{!isAssociate && (
											<li><a href="/user/team-details" className={(page === 'team-details') && "active"}>Team Details</a></li>
										)}
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="d-none d-md-block">
						<div className="techtop-adminBox">
							<img src={isAssociate ? associateUserIcon : adminUserIcon} className="img-fluid" alt="User Role" />
                            <strong>{isAssociate ? 'Associate' : 'Admin'} User</strong>
						</div>
						<div className="techtop-adminlist">
							<ul>
								<li><a href="/user/my-account" className={(page === 'my-account') && "active"}>My Account</a></li>
								{!isAssociate && (
									<li><a href="/user/team-details" className={(page === 'team-details') && "active"}>Team Details</a></li>
								)}
							</ul>
						</div>
					</div>	
				</div>
			</React.Fragment>
		)
	}
}
export default SideBar;